import React from "react"
import { useMediaQuery } from "@material-ui/core"
import { Trans } from "@lingui/macro"
import { Dialog } from ".."
import { ErrorBoundary } from "../ErrorBoundary"
import { disableBackdropClick } from "../../utils"
import { FlexBox } from "../Boxes"
import { LoadingSpinner } from "../LoadingSpinner"

const CreatorMaster = ({
  id = "CreatorMaster",
  open,
  subject,
  title: titleInput,
  navigation,
  form,
  isEdit,
  isCopy,
  isInline,
  loading,
  actions,
  onClose,
  disableEnforceFocus,
  ...rest
}) => {
  const subjectLower = subject && String(subject).toLowerCase()
  const title =
    titleInput ||
    (isEdit ? (
      <Trans>Edit {subjectLower}</Trans>
    ) : isCopy ? (
      <Trans>Copy {subjectLower}</Trans>
    ) : (
      <Trans>Create {subjectLower}</Trans>
    ))

  const xs = useMediaQuery((theme) => theme.breakpoints.down("xs"))

  const spinner = (
    <FlexBox justifyContent="center" mb={2}>
      <LoadingSpinner size={60} />
    </FlexBox>
  )

  return (
    <Dialog
      id={id}
      open={Boolean(open)}
      isInline={isInline || xs}
      title={title}
      navigation={navigation}
      actions={actions}
      onClose={isInline ? onClose : disableBackdropClick(onClose)}
      disableEnforceFocus={disableEnforceFocus}
      {...rest}
    >
      <ErrorBoundary>{loading ? spinner : form}</ErrorBoundary>
    </Dialog>
  )
}

export { CreatorMaster }
